import { useContext } from "react";
import { debugContext } from "@hudson/ui/lib";
import useContent from "@lib/use_content";
import DebugInfo from "@components/Debug/Info";
import LocationAmenityIcon from "./LocationAmenityIcon";

interface NearbyLocationParams {
  index: number;
  location: be.Location;
  onHover: (loc?: be.Location) => void;
  onSelect: () => void;
}

export default function NearbyLocation({
  index,
  location,
  onHover,
  onSelect,
}: NearbyLocationParams) {
  const { debugMode } = useContext(debugContext);
  const { data, loading, error } = useContent([
    "beNearbyLocsAway",
    "beNearbyLocsFeet",
    "beNearbyLocsMiles",
  ]);

  function niceDistance(distanceinKm: number): string {
    const distance = distanceinKm * 0.6213711922;
    const distanceInFt = distance * 5280;

    if (distanceInFt < 1000)
      return `${Math.ceil(distanceInFt / 10) * 10} ${data?.content.beNearbyLocsFeet}`;
    return `${distance.toFixed(1)} ${data?.content.beNearbyLocsMiles}`;
  }

  return (
    <div className="flex" onMouseOver={() => onHover(location)} onMouseOut={() => onHover()}>
      <div
        style={{ backgroundColor: "#f13a3a" }}
        className="relative top-[1px] flex flex-none items-center justify-center content-center rounded-full w-5 h-5 text-white "
      >
        <p className="relative justify-self-center">{index}</p>
      </div>

      <div className="grow cursor-pointer break-inside-avoid-column pl-2" onClick={onSelect}>
        <div className="flex flex-wrap gap-x-3 items-center m-0 sm:justify-between xs:mb-0.5 sm:mb-0.5 ">
          <div style={{ color: "var(--primary-color)" }} className="text-base hover:underline">
            {location.displayName}
          </div>
          {location.distance && location.distance > 0 ? (
            <div className="m-0 text-sm sm:text-sm text-gray-400 font-light">
              {niceDistance(location.distance)} {data?.content.beNearbyLocsAway}
            </div>
          ) : null}
        </div>
        {location.city && (
          <p className="break-before-avoid font-normal text-gray-600 text-xs m-0">
            {location.displayAddress}, {location.city}
            {location.state && `, ${location.state}`}
            {location.zip && `, ${location.zip}`}
          </p>
        )}{" "}
        {location.icons && (
          <div className="flex gap-x-2 items-center mt-2 mb-3">
            {location.icons.map((icon) => (
              <LocationAmenityIcon key={icon} type={icon} className="inline" />
            ))}
          </div>
        )}
        {location.description && (
          <p className="break-before-avoid font-thin  text-sm m-0 mt-2  flex ">
            <p className="pl-2 border-l-4  text-gray-800 font-normal">{location.description}</p>
          </p>
        )}
        {debugMode && location.raw && (
          <DebugInfo
            className="inline-block mt-2"
            dialogContent={<pre>{JSON.stringify(JSON.parse(location.raw), null, 2)}</pre>}
          >
            source
          </DebugInfo>
        )}
      </div>
    </div>
  );
}
